/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PregnancyMonitoringPlanInvestigationStatus {
    TO_DO = 'toDo',
    NEED_TO_INVESTIGATE = 'needToInvestigate',
    EXPIRED = 'expired',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
}
